import { NewRelic } from '@/monitoring/newrelic'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

async function enableMocking() {
  if (process.env.NODE_ENV === 'development') {
    const { worker } = await import('./services/mockApi/msw')
    return worker.start({ onUnhandledRequest: 'error' })
  }
}

enableMocking()
  .then(() => {
    const rootElement = document.getElementById('root')

    if (!rootElement) {
      throw new Error('Root element not found')
    }

    NewRelic.init()

    createRoot(rootElement).render(
      <StrictMode>
        <App />
      </StrictMode>,
    )
  })
  .catch((error) => {
    NewRelic.noticeError('APP', error)
  })
